import { DropdownSelectionItemModel } from '@_types/atoms';
import { getModifiers } from '@helpers/functions';
import Icon from '@atoms/icons/Icon';

const DropdownSelectionItem = (model: DropdownSelectionItemModel) => {
  const styleModifiers = getModifiers(model, 'kf-a-dropdown-selection-item');
  const { text, value, dataSet } = model;

  return (
    <span className={styleModifiers} data-value={value} {...dataSet} role="button">
      {text && <span className="kf-a-dropdown-selection-item__text">{text}</span>}
      <button className="kf-a-dropdown-selection-item__remove-button">
        <Icon className="kf-a-dropdown-selection-item__remove-icon" iconPath="#kf-close" viewBoxHeight={20} viewBoxWidth={20} />
      </button>
    </span>
  );
};

export default DropdownSelectionItem;
